import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import toast from "react-hot-toast";
import InputError from "../../../Components/InputError/InputError";
import { changeStatus, createJobOrder, getJobOrder, updateJobOrder } from "../../../Helpers/apiCalls/Manage/JobOrder";
import { getBranchId, getTodayDateISO, getType, toastStyle } from "../../../Helpers/Utils/Common";
import ApproveModal from "../../../Components/Modals/ApproveModal";
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";
import { getAllBranches } from "../../../Helpers/apiCalls/branchApi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import upload from "../../../Assets/Images/upload.png";
import Upload from "antd/es/upload/Upload";
import FileExceedModal from "../../../Components/Modals/FileExceedModal";
import Modal from "antd/es/modal/Modal";
import trash from "../../../Assets/Images/trash.png";
import Select from "react-select";
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi";
import Compressor from "compressorjs";
import { validateExpenseItems, validateExpenses } from "../../../Helpers/Validation/DailyExpenses/ExpenseValidation";
import { createExpense, getExpenses, updateExpense } from "../../../Helpers/apiCalls/Reports/DailyExpensesApi";
import noDataImg from "../../../Assets/Images/no-data-img.png";
import Footer from "../../../Components/Footer/Footer";

/*
    -- VIEW BUILT ITEM
*/
export default function ExpensesForm({add, edit}) {
    const { Dragger } = Upload;
    const { type, id } = useParams();
    let navigate = useNavigate();
    const accountType = getType();
    const [isClicked, setIsClicked] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showDisapproveModal, setShowDisapproveModal] = useState(false);
    const [items, setItems] = useState([]);
    const [branches, setBranches] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [prevAttachments, setPrevAttachments] = useState([]);
    const [showFileExceedModal, setShowFileExceedModal] = useState(false);
    const [preview, setPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState("");
    const [suppliers, setSuppliers] = useState([]);
    const [materialsRequired, setMaterialsRequired] = useState([
        { id: "", quantity: "1", unit: "", unitList: [] },
    ]);
    // BUILT ITEM INFO VARIABLES
    const [employees, setEmployees] = useState([]);
    const [addDetails, setAddDetails] = useState({
        expense_date: getTodayDateISO(),
        branch_id: "",
        encoded_by: "",
        datetime: "",
        overtime: "",
        items: [{actual_timein: "", actual_timeout: ""}],
        items: [{name: "", qty: "", unit: "", price: ""}],
    });
    const [itemError, setItemError] = useState({})

    // Error Handling
    const [isError, setIsError] = useState({
        branch_from: false,
        qty: false,
        ingredients: false,
    });

    const [inactive, setInactive] = useState(true);

    async function fetchExpenses() {
        setAddDetails([]);
        const response = await getExpenses({id: id});

        if (response.data) {
            var details = response.data.data[0]
            details.items = details.expense_item
            details.branch_id_value = {
                label: details.branch_name,
                value: details.branch_id,
            }
            details.supplier_name_value = {
                label: details.supplier_name,
                value: details.supplier_id,
            }
            details.encoded_by_value = {
                label: details.encoded_by_name,
                value: details.encoded_by,
            }
            setAddDetails(details);
            setPrevAttachments(details.attachment)
        }
    }

    function handleSetUnitList(items, buildDetails) {

        var data = buildDetails.items.map((item) => {
            let itemList = items.filter(
                (info) => info.id === item.item_id
            );
            var info = item
            info.unitList = { item_units: itemList[0]?.item_units }
            info.build_item_id = item.id //to save addDetails item id
            info.id = item.item_id //to set id to item id for the table to show the item
            return info
            }
        );
        setMaterialsRequired(data)
    }

    // ATTENDANCE CHANGE HANDLER
    function handleItemChange(e, id) {
        const { name, value} = e.target;
        var newAddData = {...addDetails};
        var items = addDetails.items
        items[id][name] = value;
        newAddData.items = items
        setAddDetails(newAddData);
    }

    const handleAddDetailsChange = (e) => {
        if (typeof e === "string") {
            setAddDetails((prevState) => ({
                ...prevState,
                ["item"]: e,
            }));
        } else {
            const { name, value } = e.target;
            
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    // SELECT DROPSEARCH CHANGE HANDLER
    function handleSelectChange(e) {
        const newList = {...addDetails};
        newList[e.name] = e.value;
        newList[e.select_value] = {
            label: e.label,
            value: e.value,
            name: e.name
        }
        if(e.name === "supplier_name") {
            newList["supplier_id"] = e.id;
        }
        setAddDetails(newList);
    }


    async function fetchBranches() {
        setBranches([]);
        const response = await getAllBranches();
        if (response.data) {
            var sortedBranches = response.data.data.sort((a, b) =>
                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            );
            let branches = sortedBranches.map((a) => {
                return {
                value: a.id,
                label: a.name,
                name: "branch_id",
                select_value: "branch_id_value"
                };
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = branches.filter((data) => {
                return data.value === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...branches]);
            }
        }
    }

    async function fetchEmployees() {
        setEmployees([]);
        const response = await getAllEmployees();
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data
                info.name = "encoded_by"
                info.select_value = "encoded_by_value"
                info.label = data.first_name + " " + data.last_name
                info.value = data.id
                return info
            })
            setEmployees(data);
        }
    }

    function AddItemBtn() {

        const newList = {...addDetails};
        var items = [...addDetails.items]
        items.push({ actual_timein: "", actual_timeout: ""})
        newList["items"] = items;
        setAddDetails(newList);

        // const newTimeSheet = { actual_timein: "", actual_timeout: ""};
        // setAddDetails((prevProduct) => [...prevProduct, newTimeSheet]);
    }

    async function handleChangeStatus(status) {
        setIsClicked(true);
        const response = await changeStatus(id, status);
        if (response.data) {
            toast.success(response.data.message, {style: toastStyle()});
            if(status === "approved") {
                setShowApproveModal(false)
            } else {
                setShowDisapproveModal(false)
            }
            navigate("/dailyexpenses")
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
            if(status === "approved") {
                setShowApproveModal(false)
            } else {
                setShowDisapproveModal(false)
            }
            navigate("/dailyexpenses")
        }
        setIsClicked(false);
    }

    async function fetchSuppliers() {
        setSuppliers([]);

        const response = await getAllSuppliers();

        if (response.data) {
        var suppliers = response.data.data.sort((a, b) =>
            a.trade_name > b.trade_name ? 1 : b.trade_name > a.trade_name ? -1 : 0
        );

        suppliers.map((supplier) => {
            var info = supplier;
            info.name = "supplier_name";
            info.select_value = "supplier_name_value"
            info.label = supplier.trade_name;
            info.value = supplier.trade_name;

            setSuppliers((prev) => [...prev, info]);
        });
        }
    }
    
    useEffect(() => {
        if(edit) {
            fetchExpenses();
        }
        fetchSuppliers();
        fetchBranches();
        fetchEmployees()
    }, []);


    const handleRemove = (selectedFile) => {
        var newlist = fileList.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFileList(newlist);
    };

    const handleBeforeUpload = (file) => {
        if (file.size > 2000000) {
            setShowFileExceedModal(true);
        } else {
            //COMPRESSING FILE
            new Compressor(file, {
                quality: 0.6,
                success: (compressedResult) => {
                    setFileList([...fileList, compressedResult]);
                },
            });
        }
        return false;
    };


    function handleRemoveItemAttachment(url) {
        
        var newList = prevAttachments.filter((data) => {return data.file_url !== url})
        setPrevAttachments(newList);
        setPreview(false)
    }

    // to delete items time in and out
    function handleRemoveTimeSheet(id) {
        const rowId = id;
        const newAddDetails = {...addDetails};
        var newTimeSheet = [...addDetails.items]
        newTimeSheet.splice(rowId, 1)
        newAddDetails.items = newTimeSheet;
        setAddDetails(newAddDetails);
    }


    function handleSave() {
        if(add) {
            handleSaveExpenses()
        } else {
            handleUpdateExpenses()
        }
    }

    async function handleSaveExpenses() {
        var errors = validateExpenseItems(addDetails.items)
        setItemError(errors)
        if (validateExpenses(addDetails, setIsError) && Object.keys(errors).length === 0) {
            addDetails.attachments = fileList
            addDetails.status = "pending"
            const response = await createExpense(addDetails);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/dailyexpenses")
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        } else {
            toast.error(
                "Please fill in all required fields",
                { style: toastStyle() }
            );
        }
    }

    async function handleUpdateExpenses() {
        var errors = validateExpenseItems(addDetails.items)
        setItemError(errors)
        if (validateExpenses(addDetails, setIsError) && Object.keys(errors).length === 0) {
            addDetails.attachments = fileList
            addDetails.prev_files = prevAttachments
            const response = await updateExpense(addDetails);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/dailyexpenses")
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        } else {
            toast.error(
                "Please fill in all required fields",
                { style: toastStyle() }
            );
        }
    }

    function renderTable() {
        return (
        <Table>
            <thead>
            <tr>
                <th>Name</th>
                <th>Quantity</th>
                <th>Unit</th>
                <th>Unit Price</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {addDetails?.items?.map((item, index) => {
                return (
                <tr>
                    <td>
                        <Form.Control
                            type="text"
                            name="name"
                            value={item.name}
                            onChange={(e) => handleItemChange(e, index)}
                        />
                        {itemError[index] && itemError[index].name && (
                            <div className="validity-error callout bottom">{itemError[index].name}</div>
                        )}
                    </td>
                    <td>
                        <Form.Control
                            type="number"
                            name="qty"
                            value={item.qty}
                            onChange={(e) => handleItemChange(e, index)}
                        />
                        {itemError[index] && itemError[index].qty && (
                            <div className="validity-error callout bottom">{itemError[index].qty}</div>
                        )}
                    </td>
                    <td>
                        <Form.Control
                            type="text"
                            name="unit"
                            className="nc-modal-custom-input"
                            value={item.unit}
                            onChange={(e) => handleItemChange(e, index)}
                        />
                        {itemError[index] && itemError[index].unit && (
                            <div className="validity-error callout bottom">{itemError[index].unit}</div>
                        )}
                    </td>
                    <td className="row align-contents">
                    <Col xs={2} className="align-middle mt-2">
                        PHP
                    </Col>
                    <Col>
                        <Form.Control
                            type="number"
                            name="price"
                            value={item.price}
                            onChange={(e) => handleItemChange(e, index)}
                        />
                        {itemError[index] && itemError[index].price && (
                            <div className="validity-error callout bottom">{itemError[index].price}</div>
                        )}
                    </Col>
                    </td>
                    <td>
                    <img
                        src={trash}
                        onClick={() => handleRemoveTimeSheet(index)}
                        className="cursor-pointer"
                        alt="delete"
                    />
                    </td>
                </tr>
                );
            })}
            </tbody>
        </Table>
        );
    }


    
    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-3">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ADD EXPENSES </h1>
                    </Col>
                </Row>

                
                <div className="mt-3 edit-form">
                    <Row className="nc-modal-custom-row ">
                        <Col sm={4}>
                            Branch From
                            <label className="badge-required">{` *`}</label>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Branch..."
                                value={addDetails.branch_id_value}
                                options={branches}
                                onChange={(e) => handleSelectChange(e)}
                            />
                            <InputError
                                isValid={isError.branch_id}
                                message={"Branch is required"}
                            />
                        </Col>
                        <Col sm={4}>
                            Store
                            <label className="badge-required">{` *`}</label>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Store..."
                                value={addDetails.supplier_name_value}
                                options={suppliers}
                                onChange={(e) => handleSelectChange(e)}
                            />
                            <InputError
                                isValid={isError.supplier_name}
                                message={"Store is required"}
                            />
                        </Col>
                        <Col sm={4}>
                            Acknowledged By
                            <label className="badge-required">{` *`}</label>
                            <Select 
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Employee..."
                                value={addDetails.encoded_by_value}
                                options={employees}
                                onChange={(e) => handleSelectChange(e)}
                            />
                            <InputError
                                isValid={isError.encoded_by}
                                message={"Employee is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row ">
                        <Col sm={6}>
                            Expense Date
                            <label className="badge-required">{` *`}</label>
                            <Form.Control
                                type="date"
                                name="expense_date"
                                value={addDetails.expense_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddDetailsChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.encoded_by}
                                message={"Employee is required"}
                            />
                        </Col>
                        <Col sm={6}>
                            Invoice No.
                            <label className="badge-required">{` *`}</label>
                            <Form.Control
                                type="text"
                                name="invoice_no"
                                value={addDetails.invoice_no}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddDetailsChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.invoice_no}
                                message={"Invoice No. is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row ">
                        <Col>
                            Remarks
                            {/* <label className="badge-required">{` *`}</label> */}
                            <Form.Control
                                type="text"
                                name="remarks"
                                value={addDetails.remarks}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddDetailsChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4 pt-3">
                        <Col>
                        <span className="edit-label mb-2">
                        Items <label className="badge-required">{` *`}</label>
                        </span>
                        <div className="edit-purchased-items">
                            {addDetails?.items?.length === 0 ? (
                                <span>No Item Found!</span>
                            ) : (
                                renderTable()
                            )}
                        </div>
                        </Col>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Col>
                        <Button type="button" onClick={() => AddItemBtn()}>
                            Add
                        </Button>
                        </Col>
                    </Row>
                    {
                    edit && (
                        <>
                        <div className="mt-4 noPrint mx-3">
                            <Row className="review-data mb-2">
                                FILE ATTACHMENTS
                            </Row>
                            <Row className="">
                                {
                                    prevAttachments && prevAttachments.map((attachment) => (
                                        <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                            <img src={attachment.file_url}  className="img-preview"/>
                                        </Col>
                                    ))
                                }
                                {
                                    !prevAttachments || prevAttachments.length === 0 && 
                                    <Col xs={1}>
                                    <div className="no-data-cont d-flex justify-content-left preview-container">
                                        <img src={noDataImg} alt="no data found" className="img-preview"/>
                                    </div>
                                    </Col>
                                }
                            </Row>
                        </div>
                        </>
                    )
                    }
                    <Row className="mt-4 mb-2">
                        <Col>
                            <Dragger
                                fileList={fileList}
                                onRemove={handleRemove}
                                beforeUpload={handleBeforeUpload}
                                multiple={false}
                                listType="picture"
                                progress={{ showInfo: true }}
                                // accept=".xlsx" // Accept only XLSX files
                            >
                                <img src={upload} className="cursor-pointer" />
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    </Row>
                </div>
                <div className="d-flex justify-content-end pt-5 pb-3">
                    <button
                        type="button"
                        className="button-secondary me-3"
                        onClick={() => navigate("/dailyexpenses")}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="button-primary"
                        onClick={() => handleSave()}
                    >
                        Save
                    </button>
                </div>
            </div>
            <ApproveModal
                show={showApproveModal}
                hide={() => setShowApproveModal(false)}
                type="approve"
                text="approve this job order"
                handler={() => handleChangeStatus("approved")}
                isClicked={isClicked}
            />
            <ApproveModal
                show={showDisapproveModal}
                hide={() => setShowDisapproveModal(false)}
                type="disapprove"
                text="disapprove this job order"
                handler={() => handleChangeStatus("reject")}
                isClicked={isClicked}
            />
            <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
                <Row className="justify-content-center">
                    <img
                        alt="example"
                        style={{
                        width: '100%',
                        }}
                        src={previewFile}
                    />
                    <div className="mt-2 d-flex justify-content-center">
                        <img
                            src={trash}
                            alt="trash"
                            onClick={() => handleRemoveItemAttachment(previewFile)}
                            className="cursor-pointer"
                        />
                    </div>
                </Row>
            </Modal>
            <FileExceedModal
                show={showFileExceedModal}
                onHide={() => setShowFileExceedModal(false)}
                size="2MB"
            />
            <Footer/>
        </div>
    );
}
